"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPayloadValidationError = void 0;
const httpError_1 = require("../../httpError");
const isPayloadValidationError = (error) => error instanceof httpError_1.HttpError && error.status === 400;
exports.isPayloadValidationError = isPayloadValidationError;
